<template>
  <b-card title="Histórico de Ajustes de Conta">
    <div class="custom-search d-flex justify-content-between align-items-center mb-2">
      <b-button
        variant="primary"
        @click="addNew()"
      >
        <feather-icon
          icon="PlusIcon"
          class="mr-50"
        />
        Novo Ajuste
      </b-button>
    </div>

    <vue-good-table
      mode="remote"
      :columns="columns"
      :rows="listAjustes"
      :pagination-options="{
        enabled: true,
        perPage: tableConfigs.size
      }"
      :total-rows="tableConfigs.totalElements"
      :is-loading="isLoading"
      @on-sort-change="onSortChange"
    >
      <template
        slot="table-row"
        slot-scope="props"
      >
        <!-- Action Column -->
        <span v-if="props.column.field === 'action'">
          <b-button
            variant="flat-info"
            class="btn-icon"
            size="sm"
            @click="viewDetail(props.row)"
          >
            <feather-icon icon="EyeIcon" />
          </b-button>
        </span>

        <!-- Badge for Tipo -->
        <span v-else-if="props.column.field === 'tipoContabil'">
          <b-badge :variant="props.row.tipoContabil === 'RECEITA' ? 'success' : 'danger'">
            {{ props.row.tipoContabil === 'RECEITA' ? 'Crédito' : 'Débito' }}
          </b-badge>
        </span>

        <!-- Common -->
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>

      <!-- Pagination -->
      <template
        slot="pagination-bottom"
        slot-scope="props"
      >
        <div class="d-flex justify-content-between flex-wrap mt-2">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap"> Mostrando </span>
            <b-form-select
              v-model="tableConfigs.size"
              :options="[10, 20, 50]"
              class="mx-1"
              @input="handleChangePage(1)"
            />
            <span class="text-nowrap">
              de {{ tableConfigs.totalElements }} registros
            </span>
          </div>
          <div>
            <b-pagination
              v-model="currentPage"
              :total-rows="tableConfigs.totalElements"
              :per-page="tableConfigs.size"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @change="handleChangePage"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>
  </b-card>
</template>

<script>
import {
  BCard, BButton, BBadge, BPagination, BFormSelect,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import { mapState } from 'vuex'
import mixinsGlobal from '@/mixins'

export default {
  name: 'AjusteContaList',
  components: {
    BCard, BButton, BBadge, BPagination, BFormSelect, VueGoodTable,
  },
  mixins: [mixinsGlobal],
  data() {
    return {
      isLoading: false,
      currentPage: 1,
      pageConfig: {
        page: 1,
        size: 10,
        sort: 'data',
        order: 'desc',
      },
      tableConfigs: {
        totalPages: 0,
        totalElements: 0,
        size: 10,
        number: 0,
      },
      columns: [
        {
          label: 'Data', field: 'data', formatFn: this.formatDateGrid, sortable: true,
        },
        { label: 'Conta', field: 'conta.descricao', sortable: false },
        { label: 'Tipo', field: 'tipoContabil', sortable: false },
        {
          label: 'Valor', field: 'valor', formatFn: this.formatCurrencyBrazil, sortable: true,
        },
        { label: 'Usuário', field: 'user.username', sortable: false },
        { label: 'Ação', field: 'action', sortable: false },
      ],
    }
  },
  computed: {
    ...mapState('ajusteContaFinancialModule', {
      listAjustes: state => state.listAjustes,
    }),
  },
  mounted() {
    this.loadData()
  },
  methods: {
    async loadData() {
      this.isLoading = true
      try {
        const result = await this.$store.dispatch('ajusteContaFinancialModule/findAll', this.pageConfig)
        if (result && result.data) {
          this.tableConfigs.totalPages = result.data.totalPages
          this.tableConfigs.totalElements = result.data.totalElements
          this.tableConfigs.size = result.data.size
          this.tableConfigs.number = result.data.number
        }
      } catch (error) {
        this.MensagemError('Erro', 'Falha ao buscar os ajustes de conta.')
      } finally {
        this.isLoading = false
      }
    },
    handleChangePage(page) {
      this.pageConfig.page = page
      this.loadData()
    },
    onSortChange(params) {
      this.pageConfig.sort = params[0].field
      this.pageConfig.order = params[0].type
      this.pageConfig.page = 1
      this.currentPage = 1
      this.loadData()
    },
    addNew() {
      this.$store.dispatch('ajusteContaFinancialModule/reset')
      this.$router.push({ name: 'ajuste-conta-form' })
    },
    viewDetail(item) {
      this.$router.push({ name: 'ajuste-conta-detail', params: { id: item.id } })
    },
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
